export function AudioPlayer({ sources }: { sources: string[] }) {
  if (!sources || sources.length === 0) return null;
  return (
    <div className="space-y-2">
      {sources.map((src, idx) => (
        <audio key={idx} controls className="w-full" src={src} />
      ))}
    </div>
  );
}
